import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import TransactionLayer from "../components/child/TransactionLayer";

const BlankPagePage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="Giao dịch đơn hàng" />

        {/* BlankPageLayer */}
        <TransactionLayer />
      </MasterLayout>
    </>
  );
};

export default BlankPagePage;
